import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';

import { Input } from '../../lib/form/fields';
import { requiredField, emailField, minLength } from '../../lib/form/validators';

const RegisterForm = ({ valid, handleSubmit, onSubmit, loading }, context) => {
  const [state, setState] = useState({ pwdUnmasked: false });
  const pwdMaskToggle = () => {
    setState({ pwdUnmasked: !state.pwdUnmasked });
  };

  return (
    <form onSubmit={handleSubmit(values => onSubmit(values))}>
      <Field
        name="email"
        type="email"
        label={context.t('REGISTER-FORM.EMAIL.LABEL')}
        placeholder={context.t('REGISTER-FORM.EMAIL.PLACEHOLDER')}
        component={Input}
      />

      <Field
        name="password"
        type={state.pwdUnmasked ? 'text' : 'password'}
        label={context.t('REGISTER-FORM.PASSWORD.LABEL')}
        placeholder={context.t('REGISTER-FORM.PASSWORD.PLACEHOLDER')}
        component={Input}
        appendInput={
          <span
            className={`input-group-text ${state.pwdUnmasked ? 'text-primary' : ''}`}
            onClick={() => pwdMaskToggle()}
          >
            <i className="fa fa-eye" />
          </span>
        }
      />
      <button className="btn btn-lg btn-block btn-primary mb-3" disabled={!valid}>
        {context.t('REGISTER-FORM.BUTTON.REGISTER')}
        {loading && (
          <div className="spinner-border spinner-border-sm ml-2" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        )}
      </button>
    </form>
  );
};

RegisterForm.contextTypes = {
  t: PropTypes.func.isRequired,
};

const registerFormValidator = formProps => {
  const errors = {};
  requiredField(formProps, errors, 'email', 'REGISTER-FORM.EMAIL.ERROR_REQUIRED');
  emailField(formProps, errors, 'email', 'REGISTER-FORM.EMAIL.WRONG_FORMAT');
  requiredField(formProps, errors, 'password', 'REGISTER-FORM.PASSWORD.ERROR_REQUIRED');
  minLength(formProps, errors, 'password', 3, 'REGISTER-FORM.PASSWORD.ERROR_MIN_LENGTH');
  return errors;
};

export default reduxForm({
  form: 'RegisterForm',
  validate: registerFormValidator,
})(RegisterForm);
